import {createContext} from "react";
import {User} from "../services/types";

interface UserContextType {
    currentUser: User | null;
    setCurrentUser: Function;
    isModerator: () => boolean;
}

export const UserContext = createContext<UserContextType>({
    currentUser: null,
    setCurrentUser: () => {},
    isModerator: () => false
});